import { useState } from 'react';
import { SelectionCard } from '../features/comparison/components/SelectionCard';
import { ComparisonResult } from '../features/comparison/components/ComparisonResult';
import { getCareerYear } from '../utils/date';

const TILE_SLOPE_DEG = 6;

export const Comparison = () => {
  const [targetA, setTargetA] = useState(null);
  const [targetB, setTargetB] = useState(null);

  const bothSelected = !!(targetA && targetB);
  const careerA = targetA ? getCareerYear(targetA.startYear) : 0;
  const careerB = targetB ? getCareerYear(targetB.startYear) : 0;

  return (
    <div style={{ background: '#f7f7f7', minHeight: '100vh' }}>
      <main style={{ maxWidth: 480, margin: '0 auto', paddingBottom: 48 }}>

        {/* ヘッダー */}
        <div
          style={{
            background: '#fff',
            textAlign: 'center',
            padding: '20px 16px 16px',
            borderBottom: '3px solid #222',
          }}
        >
          <h1
            style={{
              fontSize: 26,
              fontWeight: 'bold',
              color: '#222',
              margin: 0,
              letterSpacing: '0.05em',
            }}
          >
            芸歴比較
          </h1>
        </div>

        {/* カードエリア */}
        <div style={{ padding: '20px 16px 0', display: 'flex', flexDirection: 'column', gap: 0 }}>
          <SelectionCard
            selectedTarget={targetA}
            onSelect={setTargetA}
            label="A"
            highlight={bothSelected && careerA >= careerB}
          />

          {/* VSセパレーター */}
          <div
            style={{
              position: 'relative',
              height: 0,
              margin: '0 8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
            }}
          >
            <div
              style={{
                position: 'absolute',
                left: 0,
                right: 0,
                height: 2,
                background: '#e0e0e0',
                transform: `rotate(${TILE_SLOPE_DEG}deg)`,
                transformOrigin: 'center',
              }}
            />
            <div
              style={{
                width: 86,
                height: 86,
                borderRadius: '50%',
                background: '#f7f7f7',
                border: '3px solid #222',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 23,
                color: '#222',
                fontWeight: 'bold',
                letterSpacing: '0.05em',
                flexShrink: 0,
                zIndex: 1,
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              }}
            >
              VS
            </div>
          </div>

          <SelectionCard
            selectedTarget={targetB}
            onSelect={setTargetB}
            label="B"
            highlight={bothSelected && careerB > careerA}
          />
        </div>

        {/* 比較結果 */}
        {bothSelected && (
          <div style={{ padding: '16px 16px 0' }}>
            <ComparisonResult targetA={targetA} targetB={targetB} />
          </div>
        )}

      </main>
    </div>
  );
};
